import { PendingSubscriptionEvent } from "../../../../../types"
import {
  DEFAULT_DATETIME_SECONDS_SLASH_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../utils"
import EmailIcon from "./icon"
import Summary from "./summary"

interface Props {
  event: PendingSubscriptionEvent
  onOpenEmail: (emailId: string) => void
  connectorVisible?: boolean
}

const EmailRow = ({ event, onOpenEmail, connectorVisible = true }: Props) => {
  const { event_type, created } = event

  return (
    <div className="md:flex items-center justify-between py-3 md:max-w-3xl ">
      <div className="flex items-center">
        <EmailIcon
          event_type={event_type}
          connectorVisible={connectorVisible}
        />
        <div className="ml-4 text-primary-alt-400">
          <Summary event={event} onOpenEmail={onOpenEmail} />
        </div>
      </div>
      <div className="text-neutral-400 whitespace-nowrap ml-12 md:ml-0 mt-2 md:mt-0">
        {formatDateTimeFromTimestamp(
          created,
          DEFAULT_DATETIME_SECONDS_SLASH_FORMAT
        )}
      </div>
    </div>
  )
}

export default EmailRow
